import { useWebWorkerFn } from '@vueuse/core';

import type {
  TransactionGroup,
  TransactionWithGroupProperties
} from '@/composables/useTransactionsView.types';

export function useTransactionsViewGroupper() {
  const {
    workerStatus: groupperStatus,
    workerTerminate: groupperTerminate,
    workerFn: groupTransactions
  } = useWebWorkerFn((txs: TransactionWithGroupProperties[]): TransactionGroup[] => {
    const registry = new Map<number, TransactionGroup>();
    for (const item of txs) {
      const stored = registry.get(item.groupId);
      if (stored !== undefined) {
        stored.items = stored.items.concat(item);
        registry.set(item.groupId, stored);
        continue;
      }

      registry.set(item.groupId, {
        title: item.groupTitle,
        id: item.groupId,
        items: [item]
      });
    }

    // get pending txs, delete from registry to avoid expensive sorting
    const pendingTxs = registry.get(-1);
    registry.delete(-1);

    if (pendingTxs !== undefined) {
      // prepend if present
      return [pendingTxs, ...Array.from(registry.values())];
    }

    return Array.from(registry.values());
  });

  return { groupTransactions, groupperTerminate, groupperStatus };
}
